import { LeaseFileboxRecordDto } from '../dtos/lease-filebox-record.dto';

/**
 * Lease filebox records response DTO
 */
export class LeaseFileboxRecordsResponse {
	records!: LeaseFileboxRecordDto[];
}
